import React from "react";

import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import "./App.css";


/* ============================================================
   AUTH
============================================================ */

import ProtectedRoute
  from "./components/ProtectedRoute";


/* ============================================================
   LOGIN
============================================================ */

import Login
  from "./components/Login";

import Register
  from "./components/Register";


/* ============================================================
   COMPONENTS
============================================================ */

import Dashboard
  from "./components/Dashboard";

import Tenders
  from "./components/Tenders";

import TempleTiming
  from "./components/TempleTiming";

import SpstTiming
  from "./components/SpstTiming";

import DisplayTiming
  from "./components/DisplayTiming";

import Notices
  from "./components/Notices";

import NoticesDisplay
  from "./components/NoticesDisplay";

import Layout
  from "./components/Layout";

import Photo
  from "./components/Photo";

import TempleTimingsTable
  from "./components/TempleTimingsTable";

import DarsanTime
  from "./components/DarsanTime";

import GalleryView
  from "./components/GalleryView";

import Updates
  from "./components/Updates";

import Newprofile
  from "./components/Newprofile";

import PrintPage
  from "./PrintPage";

import Searchprofile
  from "./components/Searchprofile";

import SearchDate
  from "./components/SearchDate";

import AdvancedSearch
  from "./components/AdvancedSearch";

import CollectionReport
  from "./components/CollectionReport";

import MalayalamCalendar
  from "./components/MalayalamCalendar";

import Visiting
  from "./components/Visiting";

import General
  from "./components/General";

import ProcedureDashboard
  from "./components/ProcedureDashboard";

import DoctorDashboard
  from "./components/DoctorDashboard";

import PatientHistorySearch
  from "./components/PatientHistorySearch";

import Doctor
  from "./components/Doctor";

import ReceptionNurseDashboard
  from "./components/ReceptionNurseDashboard";

import History
  from "./components/History";

import Qstatus
  from "./components/Qstatus";

import Manage
  from "./components/Manage";

import ReceptionDashboard
  from "./components/ReceptionDashboard";

import Malayalam
  from "./components/Malayalam";

import DoctorQueueDashboard from "./components/DoctorQueueDashboard";
import MeDashboard from "./components/MeDashboard";


/* ============================================================
   ROLES
============================================================ */

const DOCTOR_ROLES = [
  "Doctor",
];


const FRONTDESK_ROLES = [
  "Reception",
  "Nursing Station",
];


const MANAGE_ROLES = [
  "Doctor",
  "Admin",
];


const ALL_STAFF_ROLES = [
  "Doctor",
  "Admin",
  "Reception",
  "Nursing Station",
];



/* ============================================================
   APP
============================================================ */

function App() {

  return (

    <Router>

      <div className="app-container">

        <div className="content">

          <Routes>



            {/* ==================================================
                ROOT

                ALWAYS OPEN LOGIN
            ================================================== */}

            <Route
              path="/"
              element={
                <Navigate
                  to="/login"
                  replace
                />
              }
            />



            {/* ==================================================
                LOGIN
            ================================================== */}

            <Route
              path="/login"
              element={
                <Login />
              }
            />



            {/* ==================================================
                DOCTOR ONLY

                Doctor     ✅
                Admin      ✅

                Reception  ❌
                Nursing    ❌
            ================================================== */}

            <Route
              element={
                <ProtectedRoute
                  allowedRoles={
                    DOCTOR_ROLES
                  }
                />
              }
            >


              {/* CONSULTATION */}

              <Route
                path="/doctor"
                element={
                  <Doctor />
                }
              />



              {/* DOCTOR DASHBOARD */}

              <Route
                path="/doctor-dashboard"
                element={
                  <DoctorDashboard />
                }
              />

               <Route
                path="/MeDashboard"
                element={
                  
                    <MeDashboard />
                  
                }
              />

              <Route
                path="/doctor-queue"
                element={
                  
                    <DoctorQueueDashboard />
                  
                }
              />


              {/* PATIENT HISTORY SEARCH */}

              <Route
                path="/PatientHistorySearch"
                element={
                  <PatientHistorySearch />
                }
              />



              {/* HISTORY */}

              <Route
                path="/history"
                element={
                  <History />
                }
              />



              {/* LAYOUT */}

              <Route
                path="/layout"
                element={
                  <Layout />
                }
              />



              {/* VISITING */}

              <Route
                path="/visiting"
                element={
                  <Visiting />
                }
              />



              {/* GENERAL */}

              <Route
                path="/general"
                element={
                  <General />
                }
              />



              {/* MALAYALAM */}

              <Route
                path="/malayalam"
                element={
                  <Malayalam />
                }
              />


            </Route>



            {/* ==================================================
                FRONT DESK

                Reception       ✅
                Nursing Station ✅
                Doctor          ✅
                Admin           ✅
            ================================================== */}

            <Route
              element={
                <ProtectedRoute
                  allowedRoles={
                    FRONTDESK_ROLES
                  }
                />
              }
            >


              {/* FRONT DESK */}

              <Route
                path="/frontdesk"
                element={
                  <ReceptionDashboard />
                }
              />



              {/* PATIENT INFO */}

              <Route
                path="/newprofile"
                element={
                  <Newprofile />
                }
              />



              {/* QUEUE STATUS */}

              <Route
                path="/qstatus"
                element={
                  <Qstatus />
                }
              />



              {/* PROCEDURE */}

              <Route
                path="/procedure"
                element={
                  <ProcedureDashboard />
                }
              />



              {/* PATIENT STATUS */}

              <Route
                path="/patientstatus"
                element={
                  <ReceptionNurseDashboard />
                }
              />



              {/* SEARCH */}

              <Route
                path="/searchprofile"
                element={
                  <Searchprofile />
                }
              />



              {/* PRINT */}

              <Route
                path="/print"
                element={
                  <PrintPage />
                }
              />


            </Route>



            {/* ==================================================
                DOCTOR + ADMIN ONLY
            ================================================== */}

            <Route
              element={
                <ProtectedRoute
                  allowedRoles={
                    MANAGE_ROLES
                  }
                />
              }
            >


              <Route
                path="/manage"
                element={
                  <Manage />
                }
              />


              <Route
                path="/register"
                element={
                  <Register />
                }
              />


            </Route>



            {/* ==================================================
                ALL AUTHENTICATED STAFF
            ================================================== */}

            <Route
              element={
                <ProtectedRoute
                  allowedRoles={
                    ALL_STAFF_ROLES
                  }
                />
              }
            >


              <Route
                path="/dashboard"
                element={
                  <Dashboard />
                }
              />


              <Route
                path="/searchdate"
                element={
                  <SearchDate />
                }
              />


              <Route
                path="/advancedsearch"
                element={
                  <AdvancedSearch />
                }
              />


              <Route
                path="/collectionreport"
                element={
                  <CollectionReport />
                }
              />


              <Route
                path="/malayalamcalendar"
                element={
                  <MalayalamCalendar />
                }
              />


              <Route
                path="/tenders"
                element={
                  <Tenders />
                }
              />


              <Route
                path="/templetiming"
                element={
                  <TempleTiming />
                }
              />


              <Route
                path="/spsttiming"
                element={
                  <SpstTiming />
                }
              />


              <Route
                path="/displaytiming"
                element={
                  <DisplayTiming />
                }
              />


              <Route
                path="/notices"
                element={
                  <Notices />
                }
              />


              <Route
                path="/noticesdisplay"
                element={
                  <NoticesDisplay />
                }
              />


              <Route
                path="/photo"
                element={
                  <Photo />
                }
              />


              <Route
                path="/TempleTimingsTable"
                element={
                  <TempleTimingsTable />
                }
              />


              <Route
                path="/darsantime"
                element={
                  <DarsanTime />
                }
              />


              <Route
                path="/galleryview"
                element={
                  <GalleryView />
                }
              />


              <Route
                path="/updates"
                element={
                  <Updates />
                }
              />


            </Route>



            {/* ==================================================
                UNKNOWN URL

                ALWAYS GO LOGIN
            ================================================== */}

            <Route
              path="*"
              element={
                <Navigate
                  to="/login"
                  replace
                />
              }
            />


          </Routes>

        </div>

      </div>

    </Router>

  );

}


export default App;